import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { map } from 'lodash'

import ViewFilter from './view/ViewFilter'
import CategoriesFilter from './category/CategoriesFilter'
import LocationsFilter from './location/LocationsFilter'
import DatePickerRange from './datepicker/DatePickerRange'
import FiltersStatusBar from './FiltersStatusBar'
import { filters, filterTypes } from '../../configuration/filters'
import labels from '../../configuration/labels'
import views from '../../configuration/views'

import '../../styles/scss/components/filters/event-filters-bar.scss'

const filterComponents = {
  [filterTypes.categories]: CategoriesFilter,
  [filterTypes.dates]: DatePickerRange,
  [filterTypes.locations]: LocationsFilter,
  [filterTypes.view]: ViewFilter,
}

const EventsFiltersBar = () => {
  const currentView = useSelector((state) => state.filtersData.view)
  const [rangeLabel, setRangeLabel] = useState(labels.filteredEventsDate)
  const isCalendarView = currentView === views.monthly

  return (
    <div className="decoupled-events__events-filters-bar">
      <div className={`decoupled-events__filters-bar-container ${isCalendarView ? 'calendar-view' : 'grid-view'}`}>
        <h2>{labels.filteredEventsTitle}</h2>
        <div
          className={`decoupled-events__filters-bar ${isCalendarView ? 'calendar-view' : 'grid-view'}`}
        >
          {map(filters, (filterType) => {
            const Filter = filterComponents[filterType]

            if (filterType === filterTypes.dates) {
              if (currentView === views.monthly) return null
              
              return <Filter key={filterType} rangeLabel={rangeLabel} setRangeLabel={setRangeLabel} />
            }

            return <Filter key={filterType} />
          })}
        </div>
      </div>
      <FiltersStatusBar setRangeLabel={setRangeLabel} />
    </div>
  )
}

export default EventsFiltersBar
